import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { filter, switchMap, map, take } from 'rxjs';
import { FeatureManagementService } from 'src/shared/services/feature-management.service';

@Injectable({
  providedIn: 'root',
})
export class Public2FeatureGuard implements CanActivate {
  constructor(
    private readonly featureManagement: FeatureManagementService,
    private readonly router: Router,
  ) {}

  canActivate() {
    return this.featureManagement.featuresLoaded$.pipe(
      filter((loaded) => loaded),
      switchMap(() => this.featureManagement.isFeatureEnabled('workforceInformation')),
      take(1),
      map((isEnabled) => {
        if (!isEnabled) {
          return this.router.createUrlTree(['/public']);
        }
        return true;
      }),
    );
  }
}
